import React, { useState, useEffect } from 'react';
import { notification } from 'antd';
import WidgetUpdateOptions from './WidgetUpdateOptions';
import { Close } from '@blueprintnyc/bpnyc-common-admin/dist/icons';

const WidgetUpdate = props => {
	const { event, widgetToUpdate, setWidgetToUpdate, handleClose } = props;
	const { type } = widgetToUpdate;
	const [omniPicker, setOmniPicker] = useState({
		open: false,
		mediaPicker: false,
		from: '',
		index: null,
	});
	const [widgetProps, setWidgetProps] = useState(widgetToUpdate.props || {});
	const [targetKeys, setTargetKeys] = useState([]);

	useEffect(() => {
		setTargetKeys(widgetToUpdate.groups);
		return () => setTargetKeys([]);
	}, [widgetToUpdate]);

	const handleGroupChange = (direction, ids) => {
		const rightIDs = ids.rightIDs.map(id => parseInt(id));
		setTargetKeys(rightIDs);
		setWidgetToUpdate({
			...widgetToUpdate,
			groups: rightIDs,
			toUpdate: true,
		});
	};

	const handleChange = values => {
		setWidgetProps({ ...widgetProps, ...values });
	};

	const handlePropChange = propName => value => {
		setWidgetToUpdate({
			...widgetToUpdate,
			props: { ...widgetProps, [propName]: value },
			toUpdate: true,
		});
	};

	const handlePickOmniItem = pickedLink => {
		setOmniPicker({ open: false, mediaPicker: false, from: '', index: null });
		handlePropChange('onPress')(pickedLink);
	};

	const handlePickMedia = (media, from) => () => {
		if (media.mime_type && media.mime_type.split('/')[0] === 'video') {
			notification.error({
				message: 'Error',
				description: 'Videos on the home screen are not currently supported.',
			});
		} else {
			if (from === 'media') {
				const src =
					media && media.src
						? {
								src: media.src,
								name: media.name,
								mime_type: media.mime_type,
						  }
						: null;
				handlePropChange('source')(src);
			} else {
				handlePropChange('onPress')({ link: media.src });
			}
			setOmniPicker({ open: false, mediaPicker: false, from: '' });
		}
	};

	return (
		<div className="WidgetUpdateOptions">
			<span className="header-text">{type} Widget Options</span>
			<div className="widget-close-button" onClick={handleClose}>
				<Close color="gray" />
			</div>
			<WidgetUpdateOptions
				type={type}
				event={event}
				handlePropChange={handlePropChange}
				omniPicker={omniPicker}
				setOmniPicker={setOmniPicker}
				handlePickOmniItem={handlePickOmniItem}
				handlePickMedia={handlePickMedia}
				widgetProps={widgetProps}
				handleChange={handleChange}
				setWidgetToUpdate={setWidgetToUpdate}
				targetKeys={targetKeys}
				handleGroupChange={handleGroupChange}
				{...props}
			/>
		</div>
	);
};

export default WidgetUpdate;
